<template>
  <div v-loading.fullscreen.lock="true"></div>
</template>

<script>
export default {
  name: "Callback",
  data() {
    return {};
  }
};
</script>

<style></style>
